export const getPriceFormated = (price: any) => {
  if (typeof price !== "number" || isNaN(price)) {
    console.warn("Precio inválido:", price);
    return ["$0,00"];
  }

  const priceStr = price.toFixed(2).toString();
  const priceFormated = "$" + priceStr.replace(".", ",");
  return [priceFormated];
};
